import { PwcLoader } from '@pwc/pwc-deals-ui';

import styles from './FilesPageProjectLoader.module.scss';

const FilesPageProjectLoader = () => (
  <div className={styles['project-loader-wrapper']}>
    <PwcLoader loaderType="large" loading />
  </div>
);

export default FilesPageProjectLoader;
